<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field id="matFrmFieldProvider" style="width: 100%;">
                  <mat-label>{{ "magento.version" | translate }}</mat-label>
                  <mat-select
                    id="matebasketSalesExportOrderMagentoVersion"
                    formControlName="ebasketSalesExportMagentoVersion"
                  >
                    <mat-option value="">Please Select</mat-option>
                    <mat-option value="v1">Version 1.0</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="ebasketSalesExportMagentoUsername"
                    id="ebasketSalesExportMagentoUsername"
                    matInput
                    [placeholder]="
                    'magento.username' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="ebasketSalesExportMagentoApiKey"
                    id="ebasketSalesExportMagentoApiKey"
                    matInput
                    [placeholder]="
                    'magento.apiKey' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="ebasketSalesExportMagentoUrl"
                    id="ebasketSalesExportMagentoUrl"
                    matInput
                    [placeholder]="
                    'magento.url' |
                    translate"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
